import { observer } from 'mobx-react';
import { FC } from 'react';
import { useForm, withForm } from 'react-bootstrap-formutil';
import ScrollTop from 'components/base/ScrollTop';
import { netCurAssetsOptions, netYearIncomeOptions } from 'components/forms/AssetsInfo';
import { openAgreementModal } from 'components/forms/EnhanceProgram';
import { getAddressDetail } from 'components/forms/HomeAddress';
import { getShowCompany, jobInfoOptions } from 'components/forms/JobInfo';
import { getFullName } from 'components/forms/RealNameInfo';
import { usePowerNavigate } from 'components/PowerNavigate';
import SummaryItem from 'components/SummaryItem';
import security from 'stores/security';
import values from 'stores/values';
import { CustomerInfoType, IdTypeEnum } from 'types/customer';
import Container from '../components/Container';

const Summary: FC = () => {
    const { $params } = useForm<CustomerInfoType>();
    const { id_no, id_type, job, net_year_income, net_current_assets, company, enhance_perm } = $params;
    const isSSN = id_type === IdTypeEnum.SSN_IDS;
    const curJobItem = jobInfoOptions.find(i => i.value === job);
    const navigate = usePowerNavigate();

    const goNext = () => {
        if (isSSN) {
            navigate('../revenue');
        } else {
            navigate('../w8');
        }
    };

    const handleSubmit = () => {
        const temporaryConfirmFPSLAgreement = sessionStorage.getItem('temporaryConfirmFPSLAgreement') === '1';

        if (enhance_perm === '1' && !temporaryConfirmFPSLAgreement) {
            openAgreementModal().then((result: boolean) => {
                if (result) {
                    sessionStorage.setItem('temporaryConfirmFPSLAgreement', '1');

                    goNext();
                }
            });
        } else {
            goNext();
        }
    };

    return (
        <Container
            onSubmit={handleSubmit}
            footerButtonsProps={{
                nextBtnProps: {
                    content: __('继续')
                }
            }}>
            <h3 className="open-title mt-0">{__('OPENING ACCOUNT')}</h3>
            <ScrollTop />
            <SummaryItem
                title={__('个人信息')}
                btnOptions={{
                    text: __('View'),
                    type: 'view',
                    navigatePath: '../baseinfo'
                }}
                detailList={[
                    { label: __('姓名'), value: getFullName($params) },
                    { label: isSSN ? __('SSN') : __('证件号码'), value: id_no }
                ]}
            />
            <SummaryItem
                title={__('地址信息')}
                btnOptions={{
                    text: __('View'),
                    type: 'view',
                    navigatePath: '../address'
                }}
                detailList={[
                    {
                        label: __('居住地址'),
                        value: getAddressDetail($params)
                    }
                ]}
            />
            <SummaryItem
                title={__('Regulatory Information')}
                btnOptions={{
                    text: __('View'),
                    type: 'view',
                    navigatePath: '../job'
                }}
                detailList={[{ label: __('Employment Status'), value: curJobItem?.label }].concat(
                    getShowCompany(job) ? { label: __("Employer's Name"), value: company } : []
                )}
            />
            <SummaryItem
                title={__('Assets and Income')}
                btnOptions={{
                    text: __('View'),
                    type: 'view',
                    navigatePath: '../invest'
                }}
                detailList={[
                    {
                        label: __('Annual Net Income'),
                        value: netYearIncomeOptions.find(i => i.value === net_year_income)?.label
                    },
                    {
                        label: __('Liquid Net Worth'),
                        value: netCurAssetsOptions.find(i => i.value === net_current_assets)?.label
                    }
                ]}
            />
        </Container>
    );
};

export default withForm(observer(Summary), {
    $defaultValues: () => {
        values.setShowProgressBar(false);

        return security.customerInfo;
    }
});
